import React from 'react';
import { useTranslation } from 'react-i18next';
import { Globe } from 'lucide-react';

const LANGUAGES = [
  { code: 'pt', label: 'PT', name: 'Português' },
  { code: 'en', label: 'EN', name: 'English' },
  { code: 'es', label: 'ES', name: 'Español' }
];

export const LanguageSelector: React.FC = () => {
  const { i18n } = useTranslation();

  // Extract base language code (e.g., 'pt-BR' -> 'pt')
  const currentLang = (i18n.language || 'pt').split('-')[0].toLowerCase();

  const handleLanguageChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    i18n.changeLanguage(e.target.value);
  };

  return (
    <div className="relative inline-flex items-center space-x-1.5 bg-[#0C0E14] border border-gray-800 rounded-sm px-2.5 py-1 text-xs text-gray-300 hover:border-[#00F0FF]/40 transition-colors">
      <Globe size={14} className="text-[#00F0FF]" />
      <select
        value={currentLang}
        onChange={handleLanguageChange}
        aria-label="Select Language"
        className="bg-transparent text-gray-200 font-mono focus:outline-none cursor-pointer pr-1"
      >
        {LANGUAGES.map((lang) => (
          <option key={lang.code} value={lang.code} className="bg-[#0C0E14] text-gray-200 font-mono">
            {lang.label} ({lang.name})
          </option>
        ))}
      </select>
    </div>
  );
};
